import { styled } from "@vitality-ds/system";
import baseStatusBadgeIconStyles from "./styles/BaseStatusBadge.styles";
export default styled("span", baseStatusBadgeIconStyles);